import Component from '../core/Component';

export default class TextInput extends Component {

    constructor($element) {
        super($element);
    }

    prepare() {
        this.$element
            .on('focus', 'input, textarea', ::this.handleFocus)
            .on('blur', 'input, textarea', ::this.handleBlur)
    }

    handleFocus() {
        this.$element.addClass('is-active')
    }

    handleBlur() {
        if (event.target.value.length == 0) {
            this.$element.removeClass('is-active')
        }
    }
}


// WEBPACK FOOTER //
// ./components/TextInput.js